/*NOTE 10.1 -- THESE ARE NOW NORMALIZED IN THE RESP TO TEXT_NOTE */

var DocTextNote = require('./text');

module.exports = DocTextNote.extend({        //include with documents : this seems to be what the fat client is creating
    notCreatable: true,
    isText: true //flag determining if doc/pg note if a text note
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/document/noteTypes/html.js
 ** module id = 278
 ** module chunks = 0
 **/